<div class="v4-layout-field">
  <span class="v4-layout-field-label">{{ "robot.rule.condition.label_property" | translate }}</span>
  <div class="v4-layout-field-control">
    <div class="v4-layout-field-row">
      <nz-radio-group [(ngModel)]="data.type" (ngModelChange)="onTypeChange($event)">
        <label nz-radio nzValue="none">{{ "robot.rule.action.opt.house_type_any" | translate }}</label>
        <label nz-radio nzValue="house">{{ "robot.rule.action.opt.house_type_house" | translate }}</label>
        <label nz-radio nzValue="group">{{ "automation-message_rules_html_按组" | translate }}</label>
        <label nz-radio nzValue="room_type">{{ "automation-message_rules_html_按房型_v2" | translate }}</label>
      </nz-radio-group>
    </div>
  </div>
</div>

<div class="v4-layout-field" *ngIf="data.type !== 'none'">
  <div class="v4-layout-field-label">
    <!-- <span *ngIf="data.type === 'room_type'">{{ 'word.house_type' | translate }}</span> -->
  </div>
  <div class="v4-layout-field-control">
    <div class="v4-layout-field-row">
      <v4-house-select
        *ngIf="data.type === 'house'"
        size="large"
        [(ngModel)]="data.value"
        (ngModelChange)="onValueChange($event)"
      ></v4-house-select>
      <v4-room-types-select
        *ngIf="data.type === 'room_type'"
        size="large"
        class="w-full"
        [placeholder]="'word.any' | translate"
        [ngModel]="data.value"
        (ngModelChange)="onValueChange($event)"
      ></v4-room-types-select>
      <nz-select
        *ngIf="data.type === 'group'"
        class="w-full"
        nzSize="large"
        [nzPlaceHolder]="'word.any' | translate"
        [ngModel]="data.value"
        (ngModelChange)="onValueChange($event)"
        [nzOptions]="optionsOfGroupList"
      ></nz-select>
    </div>

    <div class="v4-layout-field-extra" *ngIf="showRoomTypeTip && data.type === 'room_type'">
      {{ "automation-rules_html_按房型选说明" | translate }}
      <!-- The selection is for the property included in the room type, not for the room type. -->
    </div>
  </div>
</div>
